<template>
    <VJoyWrapper no-margin item-stretch direction="column" row-gap="1" align="flex-start" :data-testid="dataTestId">
        <div class="profile-workplace-preferences-item__title">
            <VJoyIcon :name="icon" />
            {{ title }}
        </div>
        <div v-if="label" class="profile-workplace-preferences-item__content">
            {{ label }}
        </div>
    </VJoyWrapper>
</template>

<script setup lang="ts">
    import {VJoyIcon, VJoyWrapper} from '@maltjoy/core-vue';
    import type {JoyIconsId} from '@maltjoy/icons';

    defineProps<{
        icon: JoyIconsId;
        title: string;
        label?: string;
        dataTestId: string;
    }>();
</script>

<style lang="scss">
    .profile-workplace-preferences-item {
        &__title {
            align-items: center;
            display: flex;
            column-gap: var(--joy-core-spacing-1);
            font-size: var(--joy-font-size-primary-300);
            font-weight: var(--joy-font-weight-bold);
        }

        &__content {
            font-size: var(--joy-font-size-primary-300);
        }
    }
</style>
